import { useEffect } from 'react';
import { useNetworkStatus } from '@/utils/networkStatus';
import { useToast } from '@/hooks/use-toast';
import { useQueryClient } from '@tanstack/react-query';

/**
 * Component to monitor network status and provide user feedback
 */
export const NetworkStatus = () => {
  const { isOnline, wasOffline } = useNetworkStatus();
  const { toast } = useToast();
  const queryClient = useQueryClient();

  useEffect(() => {
    if (!isOnline) {
      toast({
        title: "Connection Lost",
        description: "You're currently offline. Some features may not work.",
        variant: "destructive",
        duration: 5000,
      });
    } else if (wasOffline) {
      toast({
        title: "Connection Restored",
        description: "You're back online! Data will be synced.",
        duration: 3000,
      });
      // Refetch queries when coming back online
      queryClient.invalidateQueries();
    }
  }, [isOnline, wasOffline, toast, queryClient]);

  // Listen for custom reconnection events
  useEffect(() => {
    const handleReconnect = () => {
      queryClient.invalidateQueries();
    };

    window.addEventListener('network-reconnected', handleReconnect);
    return () => {
      window.removeEventListener('network-reconnected', handleReconnect);
    };
  }, [queryClient]);

  // This component doesn't render anything visible
  return null;
};

export default NetworkStatus;